const success = {
  name: 'trainingSignSuccess',
  path: 'success',
  meta: {
    title: '签到成功'
  },
  props: true,
  component: resolve => require(['../../../../../../pages/domain/sbs/training/sign/success'], resolve)
}

export default success
